module.exports = __webpack_public_path__ + "img/lock-open-white.df6884a2.svg";